import { Story } from '../../types/story';

export const parisDivorcees: Story = {
  id: 'paris-divorcees',
  title: 'Le Mariage Blanc',
  excerpt: 'Two forty-year-old divorcees on a girls\' trip to Paris discover that sometimes the best revenge on your ex-husbands is falling in love with each other over too much wine and not enough inhibition.',
  city: 'Paris',
  publishDate: '2026-01-14',
  readTime: '26 min read',
  tags: ['♀♀', 'divorce', 'wine', 'intimate', 'rediscovery'],
  categories: ['romantic', 'queer'],
  intensity: 3,
  content: `The problem with being forty is that you're supposed to have it all figured out. Career, kids, mortgage, the whole package. The problem with being divorced at forty is that you have to figure it all out again.

"Another bottle?" Claire asked, swirling the last of the Bordeaux in her glass. We were sitting at a tiny table outside a café in Saint-Germain, watching Paris go by in its effortless way.

"God, yes," I said. "We're on vacation. We're divorced. We're in Paris. I think we're required to get drunk."

Claire laughed and flagged down the waiter. We'd been best friends since college, had gotten married within a year of each other, had gotten divorced within a year of each other. Her husband had left her for his yoga instructor. Mine had left me because I'd "lost my spark." Apparently forty-year-old women aren't supposed to have sparks anymore.

"To being sparkless," Claire said, raising her glass after the waiter brought another bottle.

"To being sparkless," I echoed, and we clinked glasses.

The wine was good—really good—and the conversation flowed easier with each glass. We talked about our ex-husbands, about the dating apps we'd tried and deleted, about the way men our age either wanted someone twenty-five or someone to take care of them.

"I swear," Claire said, leaning in conspiratorially, "the last guy I went out with spent the entire dinner explaining cryptocurrency to me. Like I was a child who couldn't possibly understand."

"Did you?"

"Hell no. I just smiled and nodded and thought about how much I'd rather be home watching Netflix."

We both laughed, and the waiter brought us another bottle without us even asking. Maybe he could tell we needed it.

"You know what I miss?" I said, after we'd both refilled our glasses. "I miss being touched. Not even sexually, just... touched. Like someone putting their hand on your back when they walk past you, or holding your hand in the car. Little things."

Claire reached across the table and put her hand on mine. "I miss that too."

Her hand was warm, soft, and I felt something stir in me that I hadn't felt in a long time. Not just loneliness, but... want.

"Remember that spring break in college?" she said, her voice softer now. "That trip to New Orleans?"

I did remember. We'd both had too much to drink, ended up sharing a bed in our cheap hotel room. There had been a moment—just a moment—when our eyes had met in the dark, when the air between us had felt charged with possibility. But we'd been twenty then, scared of everything, and we'd both pretended it didn't happen.

"I remember," I said quietly.

"You ever think about what would have happened if we'd been braver?"

"All the time."

The wine was really hitting me now, making everything feel softer, more possible. The Paris evening was settling around us, the streetlights coming on, the sound of laughter from nearby bistros.

"Let's go back to the hotel," Claire said.

"Okay."

Our hotel was in Le Marais, a beautiful old building with a creaky elevator and rooms that looked out over the Paris rooftops. We stumbled in, both of us tipsy and giggling like we were twenty again.

"I'm so drunk," I announced, falling onto the bed.

"Me too," Claire said, sitting next to me. "But it's a good drunk, you know? A Paris drunk."

"A Paris drunk is the best kind of drunk."

We lay there for a moment, the room spinning slightly, the sounds of the city floating up through the open window.

"Sarah?" Claire said quietly.

"Yeah?"

"Can I ask you something?"

"Anything."

"Do you ever think about that night in New Orleans? About what would have happened if..."

"If we'd kissed?"

"Yeah."

I turned to look at her. Her hair was spread out on the pillow, her eyes dark in the dim light. She was beautiful—always had been, but I was seeing it differently now. Seeing her as a woman, not just my best friend.

"I think about it all the time," I admitted.

"Me too."

She leaned in, and I met her halfway. The first kiss was tentative, questioning. The second was confident, knowing. The third was hungry, desperate.

Twenty years of wanting, twenty years of wondering, twenty years of what-ifs, all pouring into this moment.

Her mouth was soft, her hands gentle as they moved through my hair. I pulled her closer, my hands finding her waist, her back, the curve of her ass. She made a small sound against my lips, and I felt it everywhere.

"Are we really doing this?" I asked, my voice barely a whisper.

"I think we've been wanting to do this for twenty years," she said. "I think we were just waiting for the right moment. The right amount of wine. The right city."

She was right. Paris had a way of making things feel possible, of making you believe that anything could happen. And right now, anything felt like it was happening.

We undressed each other slowly, our hands exploring, relearning each other's bodies in a new way. I'd seen Claire in bathing suits, in workout clothes, in various states of undress over our twenty years of friendship. But this was different. This was intentional. This was desire.

Her body was beautiful—soft curves, small breasts, a stomach that showed signs of having carried two children. I kissed my way down her body, learning her, memorizing her.

"God, Sarah," she breathed as my mouth found her breast. "That feels..."

"Good?"

"So good."

I spent time there, learning what made her gasp, what made her arch her back, what made her fingers tighten in my hair. Then I moved lower, kissing her stomach, her hips, the soft skin of her inner thighs.

"Are you sure?" I asked, looking up at her.

"I've never been more sure of anything."

I lowered my head, tasted her. She was wet, ready, and when my tongue found her clit, she cried out, her hips lifting off the bed.

"Fuck," she gasped. "Fuck, that's good."

I took my time, exploring her with my mouth, my tongue, my fingers. I wanted to know everything about her, wanted to give her everything she'd been missing, everything she deserved. When she came, it was with my name on her lips, her body trembling beneath me.

I crawled back up, kissed her deep so she could taste herself on my tongue. She wrapped her arms around me, pulled me close.

"Your turn," she murmured against my lips.

She rolled me over, straddled me, and the sight of her above me—her hair wild, her eyes dark with desire, her body flushed with pleasure—was the most beautiful thing I'd ever seen.

She kissed her way down my body, her mouth hot and confident. When she reached the apex of my thighs, she looked up at me, her eyes asking permission.

"Please," I breathed.

She smiled, then lowered her head, and I lost myself in the sensation. She was good at this—really good, her tongue finding all the right spots, her fingers knowing exactly where to go. I'd been with men before, had been with my ex-husband for fifteen years, but none of them had ever touched me like this. None of them had ever known me like this.

When I came, it was with a cry that probably woke our neighbors, my body arching off the bed, my hands fisted in the sheets.

Claire crawled back up, kissed me soft and sweet. "Wow," she whispered.

"Yeah," I agreed. "Wow."

We lay tangled together afterward, our bodies slick with sweat, our breathing slowly returning to normal. The Paris night was still alive outside our window, but in here, it was just us.

"What does this mean?" I asked quietly.

"I don't know," Claire admitted. "But I know it feels right."

"It does feel right."

"Maybe this is what we needed," she said. "Maybe this is what we were both missing."

"Not a man," I said. "Not romance in the traditional sense. Just... this. Us."

"Us," she repeated, like she was testing the word. "I like the sound of that."

We made love again in the morning, slow and sweet in the early light filtering through the window. Then we ordered room service, ate croissants in bed, and talked about what came next.

"Are we going to pretend this didn't happen when we get back home?" Claire asked, feeding me a piece of chocolate croissant.

"I don't think I can pretend this didn't happen," I admitted. "I don't think I want to."

"Me neither."

"So what do we do?"

"We figure it out," she said. "Together. Like we always have."

The rest of our trip was different. We still did the tourist things—the Louvre, the Eiffel Tower, walking along the Seine—but now we were holding hands, now we were kissing in dark corners, now we were looking at each other like we were seeing each other for the first time.

On our last night, we went to a fancy restaurant, dressed up like we were on a real date. Over champagne and foie gras, we talked about the future.

"My ex-husband is going to lose his mind," Claire said, laughing.

"Mine too. He always thought we were too close."

"Maybe we were," I said. "Maybe we just didn't know what kind of close."

When we got back to the States, things were complicated. There were kids to consider, ex-husbands to deal with, friends who didn't understand. But we figured it out, together.

Six months later, I moved into Claire's house. We sold our separate houses, bought a new one together, a place that was ours, not his or hers or theirs.

Sometimes I wake up in the middle of the night and I panic—forty years old, starting over, everything different. But then I roll over and see Claire sleeping next to me, and I remember that some things are worth starting over for.

Some things are worth waiting twenty years for.

And sometimes, the best revenge on your ex-husbands isn't proving them wrong. It's proving yourself right. It's finding your spark again, even if it's in the most unexpected place, with the most unexpected person.

It's finding yourself in Paris, over too much wine and not enough inhibition, and realizing that home isn't a place. It's a person.

It's her.`
};
